import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';

const DEFAULT_OBJECT = {};
const DEFAULT_ARRAY = [];

const getSectionsStore = (state) => state?.entities?.sections || DEFAULT_OBJECT;
const getSectionIdProp = (state, props) => props?.sectionId;

const getSectionSelector = createSelector([getSectionsStore, getSectionIdProp], (sections, sectionId) => {
  const result = sections?.[sectionId];
  return isEmpty(result) ? DEFAULT_OBJECT : result;
});

export const getTaskIdListBySectionId = createSelector(getSectionSelector, (section) => {
  const result = section?.tasks;
  return isEmpty(result) ? DEFAULT_ARRAY : result;
});

export const getTaskCountBySectionId = createSelector(
  getTaskIdListBySectionId,
  taskIdList => taskIdList.length
);

export const makeGetTaskCountBySectionId = () => getTaskCountBySectionId;

export const getQueryPageBySectionId = createSelector(getSectionSelector, (section) => section?.page || 0);

export const makeGetQueryPageBySectionId = () => getQueryPageBySectionId;

const getSectionCountsSelector = createSelector(getSectionSelector, (section) => section?.sectionCounts || 0);

export const makeGetSectionCountsSelector = () => getSectionCountsSelector;

const getSectionDoneCountsSelector = createSelector(getSectionSelector, (section) => section?.sectionDoneCounts || 0);

export const makeGetSectionDoneCountsSelector = () => getSectionDoneCountsSelector;

const getSectionTitleSelector = createSelector(getSectionSelector, (section) => section?.title);

export const makeGetSectionTitleSelector = () => getSectionTitleSelector;
